import * as Logger from "./logger.js";
import { HSComponent } from "./component.js";
import { HSButton } from "./button.js";
import styles from "./toolbar-button.css";
import template from "./toolbar-button.html";

export class HSToolbarButton extends HSButton {
    constructor() {
        super();
    }

    async onLoad() {
        this.loadTemplate(template);
        this.loadStyles(styles);
        super.onLoad();
    }
}
customElements.define("hs-toolbar-button", HSToolbarButton);
